import { saveEventOnAnalytics, identifyMachine, getSessionStorageItem } from '../../../utils/helpers'
import env from '../../../config/environment'
import Empresas from '../../../services/empresas'

class PainelFerramentas {
    static get $inject() {
        return ['$uibModal', '$filter', 'api', 'gql', '$scope', 'pathService', 'UsuariosService', 'Faturamento']
    }

    constructor($uibModal, $filter, api, gql, $scope, pathService, UsuariosService, Faturamento) {
        this.modal = $uibModal
        this.$filter = $filter
        this.api = api
        this.gql = gql
        this.apply = (fun) => $scope.$apply(fun)
        this.basePath = pathService.getViewUrl() + 'eficiencia-fiscal/view/'

        this.tabs = []
        this.usuarioId = UsuariosService.usuarioLogado.id
        this.UsuariosService = UsuariosService
        this.ocultarCreditosPisCofins = !['admin', 'admin_ef'].contains(UsuariosService.usuarioLogado.role);
        this.Faturamento = Faturamento

        $scope.$on(env.empresa_add, (_$event, empresa_id) => this.empresaAdicionada(empresa_id))
        $scope.$on(env.empresa_change, (_$event, empresa_id) => this.empresaChange(empresa_id))
    }

    async $onInit() {
        this.loadEmpresa()
        await this.loadFerramentasDisponiveis()
    }

    async loadEmpresa() {
        const empresa = getSessionStorageItem(env.selected_empresa)
        if (empresa) this.selectEmpresa(empresa)
    }

      async empresaChange(empresaId) {
        if (this.tabs.length > 0) {
            this.tabs = []
        }

        const empresa = await Empresas.getEmpresa(empresaId)
        this.selectEmpresa(empresa)
    }

    selectEmpresa(empresa) {
        empresa.id = parseInt(empresa.id)
        
        const query = gql`
            query CheckFeatureProdutosPorFilial {
                enabled: checkFeature(feature: "integracao_vindi", empresaId: ${empresa.id})
            }
        `

        this.selectEmpresaPromise = this.gql
            .query(query)
            .then(({ enabled }) => {
                this.isFeatureIntegracaoVindiEnabled = enabled
                this.empresa = empresa
                this.empresaView = empresa
                this.filiaisCount = empresa.filiais?.length
            })
            .then(() => this.loadFerramentasContratadas())
            .finally(() => this.apply())
    }

    async loadFerramentasDisponiveis() {
        this.ferramentasDisponiveis = await this.Faturamento.listProdutos()

        if (this.ocultarCreditosPisCofins) {
            this.ferramentasDisponiveis = this.ferramentasDisponiveis.filter(f => f.id !== 'detalhamento-creditos-pis-cofins');
        }

        this.ferramentasIdsByGrupo = this.ferramentasDisponiveis.groupBy(
            ferramenta => ferramenta.grupo || ferramenta.id,
            ferramenta => ferramenta.id
        )
    }

    loadFerramentasContratadas() {
        return this.UsuariosService
            .permissoes({ empresaId: parseInt(this.empresa.id) })
            .then(ferramentasContratadas => this.ferramentasContratadas = ferramentasContratadas)
    }

    highlight(search, empresa) {
        const raiz = this.$filter('cpfCnpj')(empresa.raizCnpj)
        const text = `${empresa.razaoSocial} - Raiz do CNPJ: ${raiz}`

        return search.split(' ').reduce(this.$filter('highlight'), text)
    }

    openFerramenta(ferramenta) {
        this.tabs = [...this.tabs, ferramenta].uniqBy(f => f.id)
        this.activeTab = ferramenta.id

        saveEventOnAnalytics('ModulosMaisUtilizados', ferramenta.nome, `${this.empresa.raizCnpj} | ${this.empresa.razaoSocial}`)
        saveEventOnAnalytics('ModulosPorUsuarios', identifyMachine(), ferramenta.nome)
        saveEventOnAnalytics('ModulosPorEmpresa', `${this.empresa.raizCnpj} | ${this.empresa.razaoSocial}`, ferramenta.nome)
    }

    closeFerramenta(ferramenta) {
        this.tabs = this.tabs.filter(f => f.id !== ferramenta.id)
    }
}

angular.module("eficienciaFiscalModule").component("painelFerramentas", {
    controller: PainelFerramentas,
    template: `
        <div class="row" ng-if="$ctrl.empresa">
            <div class="col-xs-12">
                <loading promise="$ctrl.promise" on-retry="$ctrl.loadEmpresas()">
                    <div class="well well-sm well-light">
                        <loading promise="$ctrl.selectEmpresaPromise">
                            <div ng-if="$ctrl.empresa">
                                <div ng-if="$ctrl.isFeatureIntegracaoVindiEnabled && !$ctrl.empresa.hasContrato">
                                    <highlighted>
                                        <main>
                                            <i class="fa fa-4x fa-exclamation-triangle"></i>
                                            <br />
                                            Esta empresa não está vinculada a nenhum contrato.
                                        </main>
                                        <secondary ng-if="$ctrl.empresa.permissao.admin">
                                            Acesse o menu "Configurações > Faturamento" e selecione um de seus contratos.
                                        </secondary>
                                        <secondary ng-if="!$ctrl.empresa.permissao.admin">
                                            Contate um dos administradores de sua empresa ou 
                                            <a href="javascript:Intercom('show')">fale com um de nossos consultores</a>.
                                        </secondary>
                                    </highlighted>
                                </div>

                                <div ng-if="$ctrl.isFeatureIntegracaoVindiEnabled && $ctrl.empresa.hasContrato && $ctrl.empresa.contrato.inadimplente">
                                    <highlighted>
                                        <main>
                                            <i class="fa fa-4x fa-exclamation-triangle"></i>
                                            <br />
                                            O contrato desta empresa está inadimplente há mais de 7 dias.
                                        </main>
                                        <secondary ng-if="$ctrl.empresa.permissao.admin">
                                            O seu acesso está bloqueado até que possamos confirmar o pagamento da assinatura. <br/>
                                            Caso possua alguma dúvida, <a href="javascript:Intercom('show')">clique aqui</a>
                                            para falar com um de nossos consultores.
                                        </secondary>
                                        <secondary ng-if="!$ctrl.empresa.permissao.admin">
                                            Contate um dos administradores de sua empresa ou 
                                            <a href="javascript:Intercom('show')">fale com um de nossos consultores</a>.
                                        </secondary>
                                    </highlighted>
                                </div>

                                <div ng-if="!$ctrl.isFeatureIntegracaoVindiEnabled || ($ctrl.empresa.hasContrato && !$ctrl.empresa.contrato.inadimplente)">
                                    <ef-tabs active="$ctrl.activeTab">
                                        <ef-tabs-tab 
                                            id='inicio'
                                            icon='fa-home'
                                            label='Ferramentas'>
                                            <ferramentas 
                                                empresa="$ctrl.empresa"
                                                filiais-count="$ctrl.filiaisCount"
                                                ferramentas-disponiveis="$ctrl.ferramentasDisponiveis"
                                                ferramentas-contratadas="$ctrl.ferramentasContratadas"
                                                on-open="$ctrl.openFerramenta(ferramenta)">
                                            </ferramentas>
                                        </ef-tabs-tab>

                                        <ef-tabs-tab 
                                            ng-repeat="ferramenta in $ctrl.tabs"
                                            id="{{ferramenta.id}}"
                                            icon="{{ferramenta.icon}}"
                                            label="{{ferramenta.nome}}"
                                            on-close="$ctrl.closeFerramenta(ferramenta)">
                                            <div ng-switch="ferramenta.id">
                                                <div ng-switch-when="arquivos-digitais">
                                                    <arquivos-digitais
                                                        contrato="$ctrl.empresa"
                                                        ferramentas-disponiveis="$ctrl.ferramentasIdsByGrupo['arquivos-digitais']"
                                                        ferramentas-contratadas="$ctrl.ferramentasContratadas">
                                                    </arquivos-digitais>
                                                </div>

                                                <div ng-switch-when="gestao-integrada-itens">
                                                    <gestao-integrada-itens empresa-id="$ctrl.empresa.id"></gestao-integrada-itens>
                                                </div>

                                                <div ng-switch-when="central-alertas">
                                                    <central-alertas contrato-id="$ctrl.empresa.id"></central-alertas>
                                                </div>

                                                <div ng-switch-when="auditoria-fiscal-digital-nfe">
                                                    <div 
                                                        ng-include-template="/app/module/eficiencia-fiscal/view/dashboard/auditoria-tributaria/nfe/index.html"
                                                        ng-include-variables="{contratoId: $ctrl.empresa.id}">
                                                    </div>
                                                </div>

                                                <div ng-switch-when="auditoria-integrada-icms">
                                                    <auditoria-integrada-icms contrato-id="$ctrl.empresa.id"></auditoria-integrada-icms>
                                                </div>

                                                <div ng-switch-when='cruzamento-nfe-x-efd-icms-ipi'>
                                                    <div 
                                                        ng-include-template="/app/module/eficiencia-fiscal/view/dashboard/sped/index.html"
                                                        ng-include-variables="{contratoId: $ctrl.empresa.id}">
                                                    </div>
                                                </div>

                                                <div ng-switch-when='detalhamento-creditos-pis-cofins'>
                                                    <div 
                                                        ng-include-template="/app/module/eficiencia-fiscal/view/dashboard/credito-gerado/index.html"
                                                        ng-include-variables="{contratoId: $ctrl.empresa.id}">
                                                    </div>
                                                </div>

                                                <div ng-switch-when='consulta-simples-tributacao-cest'>
                                                    <consulta-tributacao-cest contrato-id="$ctrl.empresa.id"></consulta-tributacao-cest>
                                                </div>

                                                <div ng-switch-when='consulta-ncm-tabela-tipi'>
                                                    <consulta-ncm contrato-id="$ctrl.empresa.id" on-select="$ctrl.select"></consulta-ncm>
                                                </div>

                                                <div ng-switch-when='auditoria-continua-itens'>
                                                    <div 
                                                        ng-include-template="/app/module/eficiencia-fiscal/view/dashboard/auditoria-estoque/index.html"
                                                        ng-include-variables="{contratoId: $ctrl.empresa.id}">
                                                    </div>    
                                                </div>    
                                            </div>        
                                        </ef-tabs-tab>
                                    </ef-tabs>
                                </div>
                            </div>
                        </loading>
                    </div>
                </loading>
            </div>
        </div>
    `
})
